module.exports = __webpack_public_path__ + "img/countDown3.e2d9f149.png";